import { useState, useRef, useEffect } from 'react';
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import getXcolumnJson from "./xcolumn/list";
import SearchArea from "./area/search";
import WirteOneArea from "@/pages/comp/edu/comp_stu_prescribe/common/write_one";

function CompStuPrescribeListArea(props: any) {
  let myProps = {
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    select_seq: "",
    s_date_type: 'a_date',
    s_start_date: '',
    s_end_date: '',
    s_subject: "",
    s_stu_name_like: "",
    s_writer_like: "",
    s_prescriber_like: "",
    s_is_request: "",
    s_is_success: "",
    s_is_success_check: "",
    s_state: "",
  });
  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [write_data, set_write_data] = useState({
    is_write_mode: false,
    info: {},
    is_update: false,
  });

  useEffect(() => {
    list({});
  }, []);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      is_excel_down: false,
      ...inOptObj
    };
    setListOpt(tmp_list_opt);
    if (tmp_list_opt.is_excel_down) {
      tmp_list_opt.is_paging = "";
    } else {
      tmp_list_opt.is_paging = "1";
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/comp_prescribe/comp_stu_prescribe/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
            setSelectbySelectedSeq({
              select_seq: tmp_list_opt.select_seq,
              info_arr: response.data["data"]["info_arr"],
            });
          }
        } else {

        }
      });
  };

  const setSelectbySelectedSeq = (inData: any) => {
    let opt_obj = {
      select_seq: "",
      info_arr: infoArr,
      ...inData
    };
    if (opt_obj.select_seq != "") {
      setTimeout(() => {
        if (ListComponentRef.current) {
          let active_row_arr: any = [];
          for (let i = 0; i < opt_obj.info_arr.length; i++) {
            let info = opt_obj.info_arr[i];
            if (info.row_pri_val == opt_obj.select_seq) {
              active_row_arr.push(true);
            } else {
              active_row_arr.push(false);
            }
          }
          ListComponentRef.current.set_active_row_arr(active_row_arr);
        }
      }, 100);
    }
  };

  const goDelete = (inData: any) => {
    let pre_selected_rows = ListComponentRef.current.getSelectedRows();
    let opt_obj = {
      selected_rows: pre_selected_rows,
      ...inData
    };
    let selected_rows = opt_obj.selected_rows;
    if (selected_rows.length === 0) {
      alert("선택없음.");
      return false;
    }
    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    let del_form_data = {
      "data_arr": selected_rows
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/comp_prescribe/comp_stu_prescribe/delete', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
          ListComponentRef.current.set_active_row_arr([]);
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_write_state_one = (inData: any) => {
    let opt_obj = {
      info: {},
      is_update: false,
      ...inData
    };
    let info = opt_obj.info;
    if (info && info.row_pri_val) {
      setListOpt({
        ...listOpt,
        select_seq: opt_obj.info.row_pri_val
      });
    } else {
      setListOpt({
        ...listOpt,
        select_seq: ""
      });
    }

    set_write_data({
      ...write_data,
      is_write_mode: true,
      info: opt_obj.info,
      is_update: opt_obj.is_update,
    });
  };

  const rowOnClick = (rowData: any, idx: number, e: any, key: string) => {

  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */
    let key = params.key;
    let render_str = params.value;
    if (key == "row_view_manage") {
      render_str = (
        <div className='my_flex_center'>
          <button className='btn btn-dark'
            onClick={() => {
              go_write_state_one({
                info: params.rowData,
                is_update: true,
              });
            }}
          >보기</button>
        </div>
      );
    }

    return render_str;
  };

  return (
    <div>
      {write_data.is_write_mode == false &&
        <div>
          <SearchArea
            listOpt={listOpt}
            setListOpt={setListOpt}
            list={list}
            goDelete={goDelete}
            go_write_state_one={go_write_state_one}
          ></SearchArea>
          <div className='mt-1'>
            <ListComponent
              ref={ListComponentRef}
              xColumnArr={{ ...xColumnArr }}
              infoArr={infoArr}
              gridOpt={{
                fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
                is_add_idx_num: false,
                is_add_checkbox: true,
                td_align: "center",
                height: "auto",
                is_fix_width: true,
                rowMultiSelectWithClick: false,
                onGridReady: () => {

                },

                is_all_select_row_key: true,
                rowOnClick: rowOnClick,
                customCellRenderer: customCellRenderer,
                class_name_json: {
                  table_div: "basic_list_div",
                  td_div: "row-col-div",
                  input_check: "chk_row",
                  row_input: "row-input",
                  data_row_tr: "data_row_tr",
                  active_row: "active",
                  empty_con_div: "list_empty_content_div",
                },
              }}
            ></ListComponent>
          </div>
          <Paging now_page={listOpt.now_page}
            num_per_page={listOpt.num_per_page}
            total_rec={countInfo.tot}
            onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
            is_view_num_per_page={true}
            is_show_total_rec={true}
            onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
        </div>
      }
      {write_data.is_write_mode &&
        <WirteOneArea
          info={write_data.info}
          is_update={write_data.is_update}
          closePopup={() => {
            set_write_data({
              ...write_data,
              is_write_mode: false,
            });
          }}
          refreshData={() => {
            list({});
          }}
        ></WirteOneArea>
      }
    </div>
  );
};
export default CompStuPrescribeListArea;